import { Config } from '@genial/config';
import { Utils } from '@genial/utils';

import { getFirestoreDocumentValue } from '../../utils/firebaseConfig';

import {
  CompliancePermission,
  ConsolidatedPortfolioPermission,
  PartnerPermission,
  TokenExpiredError,
  UserPermission,
} from './types';

export const permissionsFromApiQuery = async (token: string): Promise<UserPermission> => {
  const apiUrl = Utils.Normalize.ApiUrl(Config.GenialExtranetApiUrl);

  const userPermissionsRequest = await fetch(`${apiUrl}/api/usuario/ObterPermissionamentoUsuario`, {
    headers: {
      'content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
    credentials: 'same-origin',
  });

  const userPermissions = await userPermissionsRequest.json();

  return userPermissions as UserPermission;
};

export const permissionsFromFirebaseQuery = async () => {
  const partnerPermissions = (
    await getFirestoreDocumentValue('parceiros')
  ).data() as PartnerPermission;
  return {
    partners: partnerPermissions,
    compliance: (
      await getFirestoreDocumentValue('assessoresCompliance')
    ).data() as CompliancePermission,
    unicred: (await getFirestoreDocumentValue('brbUnicred')).data() as PartnerPermission,
    consolidatedPortfolio: (
      await getFirestoreDocumentValue('carteiraConsolidada')
    ).data() as ConsolidatedPortfolioPermission,
    trading: partnerPermissions.telas.trading,
  };
};

export const commissionsPermissionQuery = async (token: string): Promise<boolean> => {
  const apiUrl = Utils.Normalize.ApiUrl(Config.GenialExtranetApiUrl);
  const permission = await fetch(`${apiUrl}/api/Comissao/ObterPermissaoExibirComissoes`, {
    method: 'POST',
    headers: {
      'content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
    credentials: 'same-origin',
  });

  if (permission.status === 401) {
    throw new TokenExpiredError();
  }

  const permissionJson = await permission.json();

  return permissionJson;
};

export const insurancePermissionQuery = async (token: string): Promise<boolean> => {
  const apiUrl = Utils.Normalize.ApiUrl(Config.GenialExtranetApiUrl);
  const permission = await fetch(`${apiUrl}/api/Seguros/ObterPermissaoSeguros`, {
    method: 'POST',
    headers: {
      'content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
    credentials: 'same-origin',
  });

  if (permission.status === 401) {
    throw new TokenExpiredError();
  }

  const permissionJson = await permission.json();

  return permissionJson?.permissao;
};
